import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { CommonAction } from '@stores/common/action';
import PC from './layout/pc';
import H5 from './layout/h5';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps, BasePageState } from '../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';

interface RouteParams {
    code: string;
}

interface CarnivalProps extends BasePageProps, RouteComponentProps<RouteParams> {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    common?: CommonAction;
}

interface CarnivalState extends BasePageState {
    carnivalDetail: any;
}

@inject('app', 'common', 'user')
@observer
class Carnival extends BasePage<CarnivalProps, CarnivalState> {
    carnivalCode: string = '';  // 活动 code，来自路由参数

    state: CarnivalState = {
        loading: false,
        error: null,
        pageLoaded: false,
        carnivalDetail: null,
    };

    componentDidMount() {
        const { match } = this.props;
        this.carnivalCode = match.params.code;
        this.getCarnivalActivities();
        super.componentDidMount();
    }

    // 获取嘉年华活动详情
    getCarnivalActivities = async () => {
        const { common } = this.props;
        if (!common || !this.carnivalCode) return;
        const res = await common.getCarnivalActivities({ code: this.carnivalCode });
        console.log(res, '嘉年华');
        if (res.code == 0) {
            // 兼容 Data.data 嵌套结构
            const detail = res.data?.data || res.data;
            this.setState({
                carnivalDetail: detail,
                pageLoaded: true,
            });
            // 同步页面标题
            if (detail?.title) {
                document.title = detail.title;
            }
        } else {
            Toast.info(`${res.msg}`);
            setTimeout(()=> {
                this.props.history.push('/');
            }, 2000)
            
        }
    };

    handleImageClick = (item: any) => {
        const { app, user } = this.props;
        const { carnivalDetail } = this.state;
        const platform = app?.platform === 'h5' ? 'h5' : 'pc';
        const requiresLogin = item?.isLogin === true || carnivalDetail?.isLogin === true;
        const redirectUrl = item?.linkType == 1 ? item?.pcUrl : '';
        if (requiresLogin && user?.checkLogin && !user.checkLogin(platform, redirectUrl)) {
            return;
        }

        if (item?.linkType == 1 && item?.pcUrl) {
            window.open(item.pcUrl);
        } else if (item?.linkType == 2 && item?.externalUrl) {
            window.open(item.externalUrl);
        }
    };

    render() {
        const { app } = this.props;
        const { carnivalDetail } = this.state;
        const platform = app?.platform || 'h5';
        // 如果平台信息还未初始化，显示加载状态
        if (!app?.platform) {
            return (
                <div className={styles.loading} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh'
                }}>
                    <div>加载中...</div>
                </div>
            );
        }
        return (
            <div className={platform === 'pc' ? styles.pcWrap : styles.h5Wrap}>
                {platform === 'pc' ? (
                    <PC carnivalDetail={carnivalDetail} handleImageClick={this.handleImageClick} />
                ) : (
                    <H5 carnivalDetail={carnivalDetail} handleImageClick={this.handleImageClick} />
                )}
            </div>
        );
    }
}

export default withRouter(Carnival);
